'use memo';

import { Outlet, createFileRoute } from '@tanstack/react-router';
import { Suspense } from 'react';
import { HStack, VStack } from '@/components/Layout';
import { ViewportLoader } from '@/components/Loading';
import { Skeleton } from '@/components/ui/skeleton';
import { ScopeNodeDetailHeader } from './-components/ScopeNodeDetailHeader';
export const Route = createFileRoute('/_stacktrace/products/$id/scope/$nodeId/_layout')({
  component: Layout
});
function ScopeNodeDetailHeaderSkeleton() {
  return <VStack className="gap-4 bg-neutral-fill px-12 pt-4 shadow-xs">
      <HStack className="items-start gap-4">
        <Skeleton className="size-12 shrink-0" />
        <VStack className="grow gap-2">
          <Skeleton className="h-6 w-32 rounded-full" />
          <Skeleton className="h-8 w-72" />
        </VStack>
      </HStack>
    </VStack>;
}
function Layout() {
  return <VStack className="min-h-0 flex-1">
      <Suspense fallback={<ScopeNodeDetailHeaderSkeleton />}>
        <ScopeNodeDetailHeader />
      </Suspense>
      <Suspense fallback={<div className="flex-1 p-6">
            <ViewportLoader />
          </div>}>
        <Outlet />
      </Suspense>
    </VStack>;
}